const SVG_NS = 'http://www.w3.org/2000/svg';

const SVG_TAGS = new Set([
    'svg',
    'circle',
    'path',
    'line',
    'polyline',
    'polygon',
    'rect',
    'g',
    'defs',
    'ellipse',
    'text',
    'tspan',
    'use',
    'symbol',
]);

const flattenChildren = (items) => {
    const out = [];
    (Array.isArray(items) ? items : [items]).forEach((item) => {
        if (Array.isArray(item)) out.push(...flattenChildren(item));
        else out.push(item);
    });
    return out;
};

const appendChildren = (parent, children) => {
    flattenChildren(children).forEach((child) => {
        if (child == null || child === false) return;
        if (typeof child === 'string' || typeof child === 'number') {
            parent.appendChild(document.createTextNode(String(child)));
            return;
        }
        if (child instanceof Node) {
            parent.appendChild(child);
        }
    });
};

const toKebab = (key) => key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
const SVG_CASE_SENSITIVE_ATTRS = new Set(['viewBox']);

const setProp = (el, key, value) => {
    if (key === 'key' || key === 'children') return;

    if (key === 'className') {
        el.setAttribute('class', value);
        return;
    }
    if (key === 'ref') {
        if (typeof value === 'function') value(el);
        return;
    }
    if (key.startsWith('on') && typeof value === 'function') {
        el.addEventListener(key.slice(2).toLowerCase(), value);
        return;
    }
    if (key === 'dataset' && value && typeof value === 'object') {
        Object.assign(el.dataset, value);
        return;
    }
    if (key === 'dangerouslySetInnerHTML') {
        el.innerHTML = value.__html;
        return;
    }
    if (key === 'style' && value && typeof value === 'object') {
        Object.assign(el.style, value);
        return;
    }
    if (value == null || value === false) return;

    const attr =
        el.namespaceURI === SVG_NS &&
        /[A-Z]/.test(key) &&
        !SVG_CASE_SENSITIVE_ATTRS.has(key)
            ? toKebab(key)
            : key;
    el.setAttribute(attr, value === true ? '' : String(value));
};

export const h = (type, props, ...children) => {
    if (typeof type === 'function') {
        return type({ ...props, children: flattenChildren(children) });
    }

    const el = SVG_TAGS.has(type)
        ? document.createElementNS(SVG_NS, type)
        : document.createElement(type);

    if (props) {
        Object.entries(props).forEach(([key, value]) => setProp(el, key, value));
    }

    appendChildren(el, children);
    return el;
};

export const Fragment = ({ children }) => {
    const fragment = document.createDocumentFragment();
    appendChildren(fragment, children);
    return fragment;
};
